module.exports = __webpack_public_path__ + "img/autosense-amag-flow.f735b393.png";